import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  formGroup: {
    padding: theme.spacing(1, 0),
    '& h6': {
      fontSize: '.8rem'
    },
    '&.disabled': {
      '& h6': {
        color: 'rgba(0, 0, 0, 0.26)'
      }
    },
    '&.radio': {
      margin: theme.spacing(3, 0)
    },
    '& input': {
      color: theme.palette.primary.main,
      '&::placeholder': {
        color: theme.palette.secondary.contrastText
      }
    },
    '& fieldset': {
      borderColor: theme.palette.primary.main
    }
  },
  deleteDialogBody: {
    minHeight: 120,
    marginBottom: theme.spacing(3),
    '& h6': {
      paddingBottom: theme.spacing(2)
    },
    [theme.breakpoints.up('md')]: {
      marginBottom: theme.spacing()
    }
  },
  ageSection: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    '& > div ': {
      width: '45%'
    }
  },
  radioButtonContainer: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    color: theme.palette.primary.main
  },
  radioRoot: {
    color: theme.palette.primary.main
  }
}))
